import React from 'react';

import StoreColumn from '../components/StoreColumn';
import { initParams } from '../configs';

const { asOfDateLabel, itunesConnect, googlePlay } = initParams;

const PageContainer = () => (
  <div className="page-body market-overview">
    <div className="container m-b">
      <div className="flex-grow pb-md">
        <h1 className="text-lg m-b-xs">Store Comparison</h1>
        <p className="text-xxs">
          As of {asOfDateLabel} (updates weekly),
          <br />
          Data below is worldwide.
        </p>
      </div>
    </div>
    <div className="container">
      <div className="row">
        <StoreColumn data={itunesConnect} />
        <StoreColumn data={googlePlay} />
      </div>
    </div>
  </div>
);

export default PageContainer;
